import { FC } from 'react';

import { CompanyPages } from '../../components/Pages/CompanyPages';

export const PaymentAndDelivery: FC = () => {
  return <CompanyPages type="payment" title="Оплата и доставка" />;
};
